// extracted by mini-css-extract-plugin
export default {"wrapper":"_05Elements_wrapper__mGHfM","checkbox":"_05Elements_checkbox__kcQQn"};